/* istanbul ignore file */
import type { Level } from 'pino';

export const config = {
  level: 'info' as Level,
  disabled: false,
  pretty: false,
  datadog: false,
  forceConsole: false
} as const;
